import { Autocomplete, TextField } from '@mui/material';

export function FilterField({ value = [], onChange, options, label }) {
  function renderInput(params) {
    const { InputProps, inputProps, slotProps, ...textFieldProps } = params;

    return (
      <TextField
        {...textFieldProps}
        label={label}
        slotProps={{
          ...slotProps,
          input: {
            ...InputProps,
            ...slotProps?.input,
          },
          htmlInput: {
            ...inputProps,
            ...slotProps?.htmlInput,
          },
        }}
      />
    );
  }

  return (
    <Autocomplete
      size="small"
      multiple
      value={value}
      onChange={onChange}
      options={options}
      renderInput={renderInput}
    />
  );
}
